import hazardIcon from '../../../assets/icons/popup-hazard.svg'
import dayjs from 'dayjs';

const EventBox = (props: Props) => {
  const formatDate = (date: string) => {
    const formatted = dayjs(date).format('MMM D - h:mm A')
    return formatted
  }
  let highLightedItems = [ ]
  for(let product of props.properties.products){
    if("hazard" in product && !product["hazard"].toLowerCase().startsWith('sensor')){
      highLightedItems.push( [product["hazard"], 
                              hazardIcon,
                            `${product["parameters"][0]["comparison"]} ${product["parameters"][0]["threshold"]} 
                            ${product["parameters"][0]["thresholdUnits"]}`])
    }
  }
  return (
    <div className="flex flex-col gap-2 h-full justify-center w-auto">
      <div className='flex justify-between'> 
          <div className='flex gap-2 items-center'>
            <div className="header">
                {props.properties.eventName}
            </div>
          </div>
      </div>
      <div className="labelStyling">
        Valid from : {formatDate(props.properties.startTime)} - {formatDate(props.properties.endTime)}
      </div>
      <hr/>
      <div className="subHeader w-full h-5 flex gap-2 items-center">
        Thresholds
      </div>
      <div className='grid grid-cols-2 gap-2'>
      {
          highLightedItems.map((item, index) => (
          <>
              <div className="datafields flex gap-2 justify-left items-center bg-[#FFFFFF]">
                  <div className="w-8 h-8 flex">
                      <img src={item[1]} alt="Icon" />
                  </div>
                  <div className='flex flex-col'>
                      <div className='labelStyling'>{item[0]}</div>
                      <div className='valueStyling'> {item[2]} </div>
                  </div>
              </div>
          </>
          ))
      }
      </div>
      {
        props?.properties?.modelAlerts.length > 0 &&
        <>
          <hr/>
          <div className="subHeader w-full h-5 flex gap-2 items-center">
            Active Model Alert
          </div>
          <div className='grid grid-cols-2 gap-2'>
          {
              props?.properties?.modelAlerts.map((item, index) => (
              <>
                  <div className="datafields flex gap-2 justify-left items-center bg-[#FF5F15]/20 animate-pulse-border">
                      <div className="w-8 h-8 flex">
                          <img src={hazardIcon} alt="Icon" />
                      </div>
                      <div className='flex flex-col '>
                          <div className='labelStyling'>{item.properties.hazardType}</div>
                          <div className='valueStyling'>{`${Math.round(item.properties["max"])}  ${item.properties["thresholdUnits"]}`} </div>
                      </div>
                  </div>
              </>
              ))
          }
          </div>
        </>
      }
     
    </div>
  )
}

export default EventBox
